if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }

      get quantity() {
        return this.querySelector('quantity-input');
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      get productId() {
        return this.getAttribute('data-product-id');
      }

      get select() {
        return this.querySelector('select');
      }

      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      connectedCallback() {
        this.productFormActions = document.querySelector('.main-product-form');
        this.mainProductInfo = document.querySelector('product-info');
        this.container = this.closest('.sticky-atc-bar');

        this.variantData = this.getVariantData();

        // ✅ Set the correct image + button state on initial load
        const defaultVariantId = this.select.value;
        this.handleVariantChange(defaultVariantId);

        this.init();
        this.observeVariantSelectChange();

        this.select.addEventListener('change', () => {
          if (this.isUpdating) return;
          this.isUpdating = true;

          this.updateQuantityInput();

          this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          this.handleVariantChange(selectedVariantId);

          if (this.mainVariantSelects) {
            Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
              const variantOptionVal = this.currentVariant.options[index];
              switch (element.tagName) {
                case 'SELECT':
                  element.value = variantOptionVal;
                  const options = element.querySelectorAll('option');
                  options.forEach((option) => option.removeAttribute('selected'));

                  element.value = variantOptionVal;
                  const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
                  if (selectedOption) {
                    selectedOption.setAttribute('selected', 'selected');
                  }
                  break;
                case 'FIELDSET':
                  Array.from(element.querySelectorAll('input')).forEach((radio) => {
                    if (radio.value === variantOptionVal) {
                      radio.checked = true;
                    }
                  });
                  break;
              }
            });
            setTimeout(() => {
              this.mainVariantSelects.dispatchEvent(new Event('change', { detail: { formStickty: true } }));
              this.isUpdating = false;
            }, 0);
          } else {
            this.isUpdating = false;
          }

          this.updatePrice();
          this.updateButton(true, '', false);

          if (!this.currentVariant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!this.currentVariant.available, FoxTheme.variantStrings.soldOut);
          }
        });
      }

      observeVariantSelectChange() {
        const variantSelect = this.querySelector('.sticky-atc-bar__variant-select');
        if (!variantSelect) return;

        let lastValue = variantSelect.value;

        const checkVariantChange = () => {
          const currentValue = variantSelect.value;
          if (currentValue !== lastValue) {
            lastValue = currentValue;
            this.handleVariantChange(currentValue);
          }
        };

        // Fallback polling (handles programmatic changes)
        this._variantSelectInterval = setInterval(checkVariantChange, 300);
      }

      handleVariantChange(variantId) {
        this.currentVariant = this.variantData.find((v) => v.id === Number(variantId));
        if (!this.currentVariant) return;

        const variantImage = this.currentVariant.featured_image;
        const imageElement = this.querySelector(`#StickyVariantImage-${this.sectionId}`);
        if (imageElement) {
          if (variantImage && variantImage.src) {
            imageElement.src = variantImage.src;
          } else {
            // Use product-level default image if no variant image is available
            const productImage = imageElement.dataset.productImage; // This must be set in your HTML

            imageElement.src = productImage || imageElement.dataset.defaultSrc;
          }
        }

        this.updatePrice();
        this.updateButton(!this.currentVariant.available, FoxTheme.variantStrings.soldOut);
      }

      disconnectedCallback() {
        if (this._variantSelectInterval) {
          clearInterval(this._variantSelectInterval);
        }
      }

      updateQuantityInput() {
        const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
        this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

        if (!this.currentVariant) return;

        fetch(`${this.getAttribute('data-url')}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const quantity = document.querySelector(`#QuantitySticky-${this.sectionId}`);
            const newQuantity = parsedHTML.querySelector(`#QuantitySticky-${this.sectionId}`);
            if (newQuantity) {
              quantity.innerHTML = newQuantity.innerHTML;
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          return;
        }

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        // The rootMargin top offset and the boundingClientRect.top threshold below
        // MUST use the same value, or isIntersecting flips at a different line than
        // the top < 0 test expects — which was the source of the "shows randomly" bug.
        const STICKY_OFFSET = 80;
        const rootMargin = `-${STICKY_OFFSET}px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                // Target is visible — hide sticky bar
                this.container.classList.remove('sticky-atc-bar--show');
              } else if (entry.boundingClientRect.top < STICKY_OFFSET) {
                // Target has been scrolled above the offset line — show sticky bar
                this.container.classList.add('sticky-atc-bar--show');
              } else {
                // Target is below viewport (page load / not reached yet) — hide sticky bar
                this.container.classList.remove('sticky-atc-bar--show');
              }
            });
          },
          { threshold: 0, rootMargin }
        );
        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      setObserveTarget() {
        if (!this.observer) return; // ← add this guard

        const isMobile = window.matchMedia(FoxTheme.config.mediaQueryMobile).matches;
        const mobileTarget = document.querySelector('.product__block--buy_buttons');
        const target = (isMobile && mobileTarget) ? mobileTarget : this.productFormActions;

        if (this.observeTarget) {
          this.observer.unobserve(this.observeTarget);
        }

        this.observer.observe(target);
        this.observeTarget = target;
      }

      checkDevice(e) {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', this.clientHeight + 'px');
        this.setObserveTarget(); // re-target on viewport change
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('#product-form-sticky-atc-bar');
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }
      }

      updatePrice() {
        if (!this.currentVariant) return;

        const classes = {
          onSale: 'f-price--on-sale',
          soldOut: 'f-price--sold-out',
        };

        const selectors = {
          priceWrapper: '.f-price',
          salePrice: '.f-price-item--sale',
          compareAtPrice: ['.f-price-item--regular'],
          unitPriceWrapper: '.f-price__unit-wrapper',
        };

        const moneyFormat = FoxTheme.settings.moneyFormat;
        const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } = FoxTheme.utils.queryDomNodes(
          selectors,
          this
        );
        const unitPrice = unitPriceWrapper.querySelector('.f-price__unit');

        const { compare_at_price, price, unit_price_measurement } = this.currentVariant;

        if (compare_at_price && compare_at_price > price) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        if (!this.currentVariant.available) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        if (salePrice) {
          salePrice.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);
        }

        if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
          compareAtPrice.forEach(
            (item) => (item.innerHTML = FoxTheme.Currency.formatMoney(compare_at_price, moneyFormat))
          );
        } else {
          compareAtPrice.forEach((item) => (item.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat)));
        }

        if (unit_price_measurement && unitPrice) {
          unitPriceWrapper.classList.remove('hidden');
          const unitPriceContent = `<span>${FoxTheme.Currency.formatMoney(
            this.currentVariant.unit_price,
            moneyFormat
          )}</span>/<span data-unit-price-base-unit>${FoxTheme.Currency.getBaseUnit(this.currentVariant)}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else {
          unitPriceWrapper.classList.add('hidden');
        }
      }

      syncWithMainProductForm() {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
          if (!isMainProduct) return;

          const variant = event.data.variant;
          const variantInput = this.querySelector('[name="id"]');

          this.currentVariant = variant;
          variantInput.value = variant.id;

          this.updatePrice();
          this.updateButton(true, '', false);
          if (!variant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
          }

          this.updateQuantityInput();
        });
      }
    }
  );
}